import Markdown from "react-markdown"

import Link from "@mui/material/Link"

const renderer = {
  a: ({ children, href }: any) => (
    <Link
      href={href}
      target={
        href.slice(0, 20) === "https://www.carpaddy" ||
        href.slice(0, 20) === "https:/app.carpaddy"
          ? undefined
          : "_blank"
      }
    >
      {children}
    </Link>
  ),
}

export const MarkDown = ({ children }: any) => {
  return <Markdown components={renderer}>{children}</Markdown>
}

export default MarkDown
